import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CheckCircle, Home, Package } from 'lucide-react';
import { Button } from '@/components/ui/button';

const OrderSuccessPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const orderData = location.state?.orderData;
  const isDemo = orderData?.vendor_id === 'demo-restaurant-001';

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-emerald-50 to-green-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl p-8 text-center animate-fade-in">
        {/* Success Icon */}
        <div className="w-20 h-20 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-12 h-12 text-white" />
        </div>

        {/* Success Message */}
        <h1 className="text-3xl font-bold text-gray-800 mb-3">
          Order Successfully Placed!
        </h1>

        {/* Order Details */}
        {orderData && (
          <div className="bg-gray-50 rounded-xl p-4 mb-6 text-left">
            <h3 className="font-semibold text-gray-800 mb-2">Order Summary</h3>
            <div className="space-y-1 text-sm text-gray-600">
              <div className="flex justify-between">
                <span>Order ID:</span>
                <span className="font-medium text-gray-800">#{orderData.id?.slice(0, 8)}</span>
              </div>
              <div className="flex justify-between">
                <span>Items:</span>
                <span className="font-medium text-gray-800">{orderData.items?.length}</span>
              </div>
              <div className="flex justify-between">
                <span>Total Amount:</span>
                <span className="font-bold text-green-600">₹{orderData.total_amount}</span>
              </div>
            </div>
          </div>
        )}

        <p className="text-gray-600 mb-8">
          Your order has been placed successfully and is being processed.
        </p>

        {/* Action Buttons */}
        <div className="space-y-3">
          <Button
            onClick={() => navigate('/')}
            className="w-full btn-primary text-white py-3 rounded-xl font-semibold flex items-center justify-center gap-2"
            data-testid="go-to-home-button"
          >
            <Home className="w-5 h-5" />
            Go to Home
          </Button>

          <Button
            onClick={() => navigate('/orders')}
            className="w-full bg-white border-2 border-green-600 text-green-600 hover:bg-green-50 py-3 rounded-xl font-semibold flex items-center justify-center gap-2"
            data-testid="view-orders-button"
          >
            <Package className="w-5 h-5" />
            View Orders
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccessPage;
